(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ambrelle-cancellation"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ambrelle-cancel')) {
    class AmbrelleCancel extends HTMLElement {
      connectedCallback() {
        this.form = this.closest('form');
        if (!this.form) return;
        this.form.addEventListener('submit', (event) => this.submit(event));
        this.querySelector('[data-back]')?.addEventListener('click', () => this.step('edit'));
        const review = this.querySelector('[data-review]');
        if (review && review.dataset.label) review.textContent = review.dataset.label;
        const date = this.querySelector('[data-date]');
        const sync = () => {
          const specific = this.querySelector('input[type=radio][data-specific]');
          if (date && specific) date.required = specific.checked;
        };
        this.querySelectorAll('input[name="contact[when]"]').forEach((radio) => radio.addEventListener('change', sync));
        date?.addEventListener('input', () => {
          const specific = this.querySelector('input[type=radio][data-specific]');
          if (date.value && specific) {
            specific.checked = true;
            sync();
          }
        });
        sync();
      }

      formatDate(value) {
        try {
          return new Intl.DateTimeFormat(document.documentElement.lang || undefined, { dateStyle: 'long' }).format(new Date(value + 'T12:00:00'));
        } catch (error) {
          return value;
        }
      }

      /* Étape 1 → récapitulatif ; étape 2 → envoi réel. */
      submit(event) {
        if (this.dataset.step === 'review') return;
        event.preventDefault();
        if (!this.form.reportValidity()) return;
        const list = this.querySelector('[data-summary]');
        list.replaceChildren();
        this.querySelectorAll('[data-edit] .ambrelle-cancel__field').forEach((field) => {
          const label = field.querySelector('span, legend');
          let value = '';
          const input = field.querySelector('input:not([type=radio]):not([type=date]), textarea');
          const radio = field.querySelector('input[type=radio]:checked');
          if (radio) {
            value = radio.value;
            const date = field.querySelector('input[type=date]');
            if (radio.dataset.specific !== undefined && date && date.value) value += (this.dataset.join || ', ') + this.formatDate(date.value);
          } else if (input) {
            value = input.value;
          }
          if (!value.trim()) return; // ligne vide (motif facultatif non rempli) : non affichée
          const dt = document.createElement('dt');
          const dd = document.createElement('dd');
          dt.textContent = label ? label.textContent.trim() : '';
          dd.textContent = value;
          list.append(dt, dd);
        });
        this.step('review');
      }

      step(name) {
        this.dataset.step = name;
        this.querySelector('[data-edit]').hidden = name === 'review';
        this.querySelector('[data-review-panel]').hidden = name !== 'review';
        const target = name === 'review' ? this.querySelector('[data-review-title]') : this.querySelector('[data-edit] input');
        target?.focus();
      }
    }

    customElements.define('ambrelle-cancel', AmbrelleCancel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ambrelle-collection"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Tri : envoi du formulaire au changement ; le bouton « Appliquer » reste pour le clavier et sans JavaScript.
    document.querySelectorAll('[data-ambrelle-coll-form]').forEach(function (form) {
      if (form.dataset.bound) return;
      form.dataset.bound = 'true';
      var select = form.querySelector('select[name="sort_by"]');
      if (!select) return;
      form.classList.add('is-enhanced');
      select.addEventListener('change', function () {
        form.requestSubmit ? form.requestSubmit() : form.submit();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ambrelle-footer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Pays / langue : envoi au changement ; le bouton reste pour le clavier et sans JavaScript.
    var form = document.getElementById('AmbrelleFootLocale');
    if (!form || form.dataset.bound) return;
    form.dataset.bound = 'true';
    form.classList.add('is-enhanced');
    form.querySelectorAll('select').forEach(function (select) {
      select.addEventListener('change', function () {
        form.requestSubmit ? form.requestSubmit() : form.submit();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ambrelle-quiz-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('ambrelle-quiz-hero')) return;
    class AmbrelleQuizHero extends HTMLElement {
      connectedCallback() {
        // Tout lien « data-quiz-start » de la page (haut, bouton fixe, appel final) descend jusqu'au quiz et le lance.
        document.addEventListener('click', (event) => {
          if (event.target.closest('[data-quiz-start]')) this.start(event);
        });
        const sticky = this.querySelector('[data-sticky]');
        const quiz = document.querySelector('ambrelle-quiz');
        const cta = this.querySelector('.ambrelle-qhero__cta');
        if (!sticky || !quiz || !cta || !('IntersectionObserver' in window)) return;
        // Le bouton fixe n'apparaît que lorsque le bouton du haut et le quiz sont tous deux hors de l'écran.
        let ctaVisible = true;
        let quizVisible = false;
        const update = () => {
          sticky.hidden = ctaVisible || quizVisible;
        };
        new IntersectionObserver(([entry]) => {
          ctaVisible = entry.isIntersecting;
          update();
        }).observe(cta);
        new IntersectionObserver(([entry]) => {
          quizVisible = entry.isIntersecting;
          update();
        }, { threshold: 0.05 }).observe(quiz);
      }

      start(event) {
        const quiz = document.querySelector('ambrelle-quiz');
        if (!quiz) return;
        event.preventDefault();
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        quiz.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
        const go = quiz.querySelector('[data-intro]:not([hidden]) [data-go="start"]');
        if (go) {
          go.click();
        }
        window.setTimeout(() => {
          const focusable = quiz.querySelector('[data-app] input, [data-app] button:not([disabled]), [data-go="start"]');
          if (focusable) focusable.focus({ preventScroll: true });
        }, reduce ? 0 : 500);
      }
    }
    customElements.define('ambrelle-quiz-hero', AmbrelleQuizHero);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ambrelle-sun-dial"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ambrelle-sun-dial')) {
    class AmbrelleSunDial extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        document.addEventListener('ambrelle:sky', () => this.update(), { signal: this.controller.signal });
        this.timer = window.setInterval(() => this.update(), 60000);
        this.observer = new IntersectionObserver((entries) => {
          if (entries.some((entry) => entry.isIntersecting)) {
            this.classList.add('is-visible');
            this.observer.disconnect();
          }
        });
        this.observer.observe(this);
        this.update();
      }

      disconnectedCallback() {
        this.controller?.abort();
        window.clearInterval(this.timer);
        this.observer?.disconnect();
      }

      format(time) {
        try {
          return new Intl.DateTimeFormat(document.documentElement.lang || undefined, { hour: '2-digit', minute: '2-digit' }).format(new Date(time));
        } catch (error) {
          return '';
        }
      }

      update() {
        const sky = window.AmbrelleSky;
        if (!sky) return;
        const state = sky.state;
        const now = Date.now();
        const sun = sky.compute(now);
        const sunrise = sun.sunrise;
        const sunset = sun.sunset;
        if (!sunrise || !sunset) return;

        const set = (selector, value) => {
          const node = this.querySelector(selector);
          if (node) node.textContent = value;
        };
        set('[data-dial-sunrise]', this.format(sunrise));
        set('[data-dial-sunset]', this.format(sunset));
        set('[data-dial-now]', this.format(now));

        const text = this.dataset.text || '';
        if (text) set('[data-dial-text]', text.replace('{sunrise}', this.format(sunrise)).replace('{sunset}', this.format(sunset)));

        let x;
        let y;
        let elapsed = 0;
        if (now >= sunrise && now <= sunset) {
          const f = (now - sunrise) / (sunset - sunrise);
          const angle = Math.PI * (1 - f);
          x = 320 + 240 * Math.cos(angle);
          y = 230 - 170 * Math.sin(angle);
          elapsed = f;
          this.dataset.phase = 'day';
        } else {
          const start = now > sunset ? sunset : sunset - 86400000;
          const end = now > sunset ? sun.next.sunrise || sunrise + 86400000 : sunrise;
          const g = Math.min(1, Math.max(0, (now - start) / (end - start)));
          x = 320 + 240 * Math.cos(Math.PI * g);
          y = 230 + 52 * Math.sin(Math.PI * g);
          elapsed = now > sunset ? 1 : 0;
          this.dataset.phase = 'night';
        }
        const dot = this.querySelector('[data-dial-sun]');
        if (dot) dot.setAttribute('transform', `translate(${x.toFixed(1)} ${y.toFixed(1)})`);
        const arc = this.querySelector('[data-dial-elapsed]');
        if (arc) arc.style.setProperty('--dial-elapsed', elapsed.toFixed(4));
      }
    }

    customElements.define('ambrelle-sun-dial', AmbrelleSunDial);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
